import { FormattedTimestamp } from "./FormattedTimestamp";
export default FormattedTimestamp;
